<template>
	<article>
		<multiple-file-drop
			:items="images"
			:is-updating="isUpdating"
			:main-image="mainImageName"
			class="u__margin-top-30 max-width u__padding-20"
			@update-file="updateFile"
			@remove-file="removeFile"
			@clear-files="images = []"
			@star-file="starFile"
		/>
		<p class="podpis u__padding-20 description-heading max-width">Opis:</p>
		<editor
			:readonly="isUpdating"
			:content="description"
			@update-content="updateDescription"
		/>
		<form class="col" autocomplete="off">
			<p class="podpis">Nazwa projektu:</p>
			<input v-model="name" type="text" placeholder="Nazwa projektu" />
			<button
				class="button__save contact__button u__margin-top-30"
				:disabled="isUpdating"
				@click.prevent="saveEntry"
			>
				<span v-if="!isUpdating">{{ $t('buttons.save') }}</span>
				<span v-else class="loader loader-small"></span>
			</button>
			<button
				v-if="id && !isUpdating"
				class="button__delete"
				@click.prevent="deleteEntry"
				:disabled="isUpdating"
			>
				USUŃ
			</button>
		</form>
		<router-link to="/edit-projects" class="back">WSTECZ</router-link>
	</article>
</template>
<script>
import MultipleFileDrop from '@/components/MultipleFileDrop'
import Editor from '@/components/Editor'

export default {
	components: {
		MultipleFileDrop,
		Editor
	},
	data: ({ $route, $store }) => ({
		slug: $route.params.project,
		labels: {
			text: 'Jesteś pewien, że chcesz skasować ten wpis?',
			success: 'wpis usunięty'
		},
		index: null,
		imagesToBeRemoved: [],
		isUpdating: false,
		images: [],
		mainImageName: null,

		name: '',
		order: $store.getters['project/data'].length,
		id: null,
		mainImageId: '',
		filter: 'project',
		link: '',
		upText: '',
		text1: '',
		text2: '',
		projectId: '',
		description: ''
	}),
	computed: {
		isDownText: ({ text2 }) => text2.length > 0
	},
	created() {
		const index = this.$store.getters['project/data'].findIndex(
			(item) => item.id === +this.slug
		)
		if (index > -1) {
			this.index = index
			this.name = this.$store.getters['project/data'][this.index].name
			this.order = this.$store.getters['project/data'][this.index].order
			this.id = this.$store.getters['project/data'][this.index].id
			this.projectId = this.$store.getters['project/data'][this.index].id
			this.description = this.$store.getters['project/data'][
				this.index
			].description
			this.mainImageId = this.$store.getters['project/data'][
				this.index
			].mainImageId
			const imageIndex = this.$store.getters['image/data'].findIndex(
				(i) => i.id === this.mainImageId
			)
			this.mainImageName = this.$store.getters['image/data'][imageIndex].name
			const images = [
				...this.$store.getters['image/data'].filter(
					(item) => +item.projectId === +this.id
				)
			].sort(this.$compareValues('order'))
			images.forEach((item) => {
				this.images.push({
					file: { name: item.name },
					preview: this.$getImgUrl(item.name),
					uploaded: true
				})
			})
		} else if (this.slug !== 'add') {
			this.$router.replace('/404')
		}
	},
	methods: {
		updateDescription(data) {
			this.description = data
		},
		findIndexByName(file) {
			return this.$store.getters['image/data'].findIndex(
				(i) => i.name === file.file.name
			)
		},
		updateFile(file) {
			this.images.push(file)
		},
		removeFile(file) {
			if (file.file.name !== this.mainImageName) {
				if (file.uploaded) {
					this.imagesToBeRemoved.push(
						this.$store.getters['image/data'][this.findIndexByName(file)].id
					)
				}
				this.images = this.images.filter(
					(item) => item.file.name !== file.file.name
				)
			} else {
				this.$alertBox({
					labels: {
						text: 'nie można usunąć głównego zdjęcia'
					},
					type: 'error'
				})
			}
		},
		starFile(name) {
			this.mainImageName = name
		},
		deleteEntry() {
			this.$alertConfirm({
				labels: this.labels,
				action: {
					name: 'project/remove',
					payload: this.id,
					async: true,
					redirect: '/edit-projects'
				}
			})
		},
		async saveEntry() {
			if (!this.mainImageName) {
				this.$alertBox({
					labels: {
						text: 'dodaj główne zdjęcie'
					},
					type: 'error'
				})
			} else {
				this.isUpdating = true

				if (this.id) {
					const promises = []
					let mainImageFormData
					this.images.forEach((item, index) => {
						const formData = new FormData()
						formData.append('filter', this.filter)
						formData.append('isDownText', this.isDownText)
						formData.append('link', this.link)
						formData.append('text1', this.text1)
						formData.append('text2', this.text2)
						formData.append('upText', this.upText)
						formData.append('order', index)
						formData.append('projectId', this.projectId)

						if (!item.uploaded) {
							formData.append('image', item.file)
							if (item.file.name === this.mainImageName) {
								mainImageFormData = { id: null, formData }
							} else {
								promises.push(this.$store.dispatch('image/create', formData))
							}
						} else {
							if (item.file.name === this.mainImageName) {
								formData.append('image', item.file)
								mainImageFormData = {
									id: this.$store.getters['image/data'][this.findIndexByName(item)].id,
									formData
								}
							} else {
								promises.push(
									this.$store.dispatch('image/update', {
										id: this.$store.getters['image/data'][this.findIndexByName(item)].id,
										formData
									})
								)
							}
						}
					})
					this.imagesToBeRemoved.forEach((item) => {
						promises.push(this.$store.dispatch('image/remove', item))
					})
					await Promise.all(promises)
					if (mainImageFormData.id) {
						const { id } = await this.$store.dispatch(
							'image/update',
							mainImageFormData
						)
						await this.$store.dispatch('project/update', this.projectToUpdate(id))
					} else {
						const { id } = await this.$store.dispatch(
							'image/create',
							mainImageFormData.formData
						)
						await this.$store.dispatch('project/update', this.projectToUpdate(id))
					}
				} else {
					const response = await this.$store.dispatch('project/create', {
						mainImageId: 0,
						name: this.name,
						order: this.order,
						description: this.description
					})
					this.id = response.id
					const promises = []
					let mainImageFormData
					this.images.forEach((item, index) => {
						const formData = new FormData()
						formData.append('filter', this.filter)
						formData.append('isDownText', this.isDownText)
						formData.append('link', this.link)
						formData.append('text1', this.text1)
						formData.append('text2', this.text2)
						formData.append('upText', this.upText)
						formData.append('image', item.file)
						formData.append('order', index)
						formData.append('projectId', this.id)
						if (item.file.name === this.mainImageName) {
							mainImageFormData = formData
						} else {
							promises.push(this.$store.dispatch('image/create', formData))
						}
					})
					await Promise.all(promises)
					const { id } = await this.$store.dispatch(
						'image/create',
						mainImageFormData
					)
					await this.$store.dispatch('project/update', this.projectToUpdate(id))
				}
				this.$alertBox({
					labels: {
						text: this.$t('alerts.saved_changes')
					},
					type: 'success',
					redirect: '/edit-projects'
				})
				this.isUpdating = false
			}
		},
		projectToUpdate(id) {
			return {
				id: this.id,
				mainImageId: id,
				name: this.name,
				order: this.order,
				description: this.description
			}
		}
	}
}
</script>
